import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { openGallerySubject } from '../../../core/services/dialog-service';
import { BaseComponent } from '../../component-base';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrl: './gallery.component.scss',
})
export class GalleryComponent extends BaseComponent {
  public index?: number = undefined;
  public images: number[] = [];
  private touchStartX = 0;
  private touchEndX = 0;

  readonly ref = inject(ChangeDetectorRef);
  constructor() {
    super();
    openGallerySubject.subscribe(data => {
      this.images = data.images;
      this.openGalleryDialog(data.index);
      this.ref.detectChanges();
    });
  }

  touchStarted(ev: TouchEvent): void {
    this.touchStartX = ev.touches[0].clientX;
    this.touchEndX = ev.touches[0].clientX; // in case there is no movement before touchEnd
  }

  touchMoved(ev: TouchEvent): void {
    this.touchEndX = ev.touches[0].clientX;
  }

  touchEnded(_ev: TouchEvent): void {
    const dir = this.touchStartX - this.touchEndX;

    if (Math.abs(dir) < 50) return;

    // swipe right
    if (dir > 0) {
      this.nextImage(1);
    } else {
      // swipe left
      this.nextImage(-1);
    }
  }

  public openGalleryDialog(startIndex: number): void {
    document.body.style.overflow = 'hidden';
    this.index = startIndex;
  }

  public closeGalleryDialog(): void {
    document.body.style.overflow = 'visible';
    this.index = undefined;
  }

  nextImage(dir: number) {
    if (this.index === undefined) return;
    this.index += dir;

    if (this.index + 1 > this.images.length) this.index = 0;
    else if (this.index < 0) this.index = this.images.length - 1;
  }
}
